import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import { useCurrentTheme } from "@/lib/theme";
import "@/index.css";

import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Senders from "@/pages/Senders";
import OAuthSenders from "@/pages/OAuthSenders";
import Recipients from "@/pages/Recipients";
import Content from "@/pages/Content";
import TestSend from "@/pages/TestSend";
import Campaigns from "@/pages/Campaigns";
import CampaignDetail from "@/pages/CampaignDetail";
import ContentPool from "@/pages/ContentPool";
import OAuthProjects from "@/pages/OAuthProjects";
import MicrosoftTenants from "@/pages/MicrosoftTenants";
import SeedMailboxes from "@/pages/SeedMailboxes";
import SeedProxy from "@/pages/SeedProxy";
import InboxPlacement from "@/pages/InboxPlacement";
import MailboxTest from "@/pages/MailboxTest";
import InboxPlacementDetail from "@/pages/InboxPlacementDetail";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#0A0A0A] text-[#71717A] font-mono flex items-center justify-center">[ LOADING... ]</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  const theme = useCurrentTheme();
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="senders/:provider" element={<Senders />} />
            <Route path="oauth-senders" element={<OAuthSenders />} />
            <Route path="recipients" element={<Recipients />} />
            <Route path="content" element={<Content />} />
            <Route path="test-send" element={<TestSend />} />
            <Route path="campaigns" element={<Campaigns />} />
            <Route path="campaigns/:id" element={<CampaignDetail />} />
            <Route path="content-pool" element={<ContentPool />} />
            <Route path="oauth-projects" element={<OAuthProjects />} />
            <Route path="microsoft-tenants" element={<MicrosoftTenants />} />
            <Route path="seed-mailboxes" element={<SeedMailboxes />} />
            <Route path="seed-proxy" element={<SeedProxy />} />
            <Route path="inbox-placement" element={<InboxPlacement />} />
            <Route path="mailbox-test" element={<MailboxTest />} />
            <Route path="inbox-placement/:id" element={<InboxPlacementDetail />} />
            <Route path="reports" element={<Reports />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" theme={theme} closeButton />
    </AuthProvider>
  );
}

export default App;
